(function($) {

	'use strict';

    var filters = {}

	var init = function() {
        
        manageJobs()

        selectWidthAdaptative()

    };

    var selectWidthAdaptative = function() {
        var arrowWidth = 40

        $('.jobs__filter__select select').each(function() {
            $(this).change(function() {
                var text = $(this).find("option:selected").text()

                var test = $('<span>').html(text).css({
                    "font-size": $(this).css('font-size'),
                    "visibility": 'hidden'
                })

                test.appendTo($(this).parent())
                var width = test.width()
                test.remove()

                $(this).width(width + arrowWidth)
            }).change()
        })
    }

    var manageJobs = function() {

        $('#jobs__filter__submit').click(function(e) {

            e.preventDefault();

            filterJobs();
            
        });

        $('.jobs__filter__type__radio label').click(function() {

            setTimeout(filterJobs, 25);

        });

        $('#jobs__filter__reset').click(function() {

            $('input[name="form_category"]:checked').prop('checked', false)

            setTimeout(function() {
                filterJobs();
            }, 25);

        });

        var filterJobs = function() {
            
            var campus = $('select#campus', '#jobs__filter').val();
            filters.camp = campus

            var contrats = $('select#contrats', '#jobs__filter').val();
            filters.contrats = contrats
            
            var level = $('input[name="level"]:checked', '#jobs__filter').val();
            if(level !==undefined) {
                filters.level = level
            } else {
                filters.level = ""
            }
            
            var type = $('input[name="form_category"]:checked', '#jobs__filter__type').val();
            if(type !== undefined) {
                filters.cat = type
            } else {
                filters.cat = ""
            }

            var top = $('.jobs-all').offset().top - $('.jobs__container').offset().top;

            jQuery.post(
                MyAjax.ajaxurl,
                {
                    'action': 'jobs_filter',
                    'level': level,
                    'type': type,
                    'contrats': contrats,
                    'campus': campus,
                    'hidden': true
                },
                function(response){
    
                    if(response != 'false'){

                        updateURL()
    
                        $('.jobs__container').css('height', $('.jobs__container').height());
    
                        $('.jobs-all').css('top', top + 'px').addClass('fade-out').fadeOut(800, function() {
                            $('.jobs-all.fade-out').remove();
                        });
    
                        $('.jobs__container').append(response);
                        
                        setTimeout(function() {
                            if($('.jobs-all.hidden')) {
                                $('.jobs__container').css('height', $('.jobs-all.hidden').height() + top + 'px');
                                $('.jobs-all.hidden').removeClass('hidden');
                            } else {
                                $('.jobs__container').css('height', 'auto');
                            }
                        }, 100);
                        
                    }
                }
            );

        }

        var updateURL = function() {
            var url = window.location.href.split("?")[0]
            var position = 0

            for (var filter in filters) {
                if(filters[filter] === null || filters[filter].length <= 0)
                continue

                if(position > 0) {
                    url += '&'
                } else {
                    url += '?'
                }

                position++
                url += filter + '=' + filters[filter]
            }
            window.history.pushState({},"", url)
        }

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);